import assets from 'config/api/assets/assets';

const assetParamsGetter = (query: any) => [assets.getAllAssets({ limit: 100, search: query })];

export default assetParamsGetter;
